import { supabase } from "../supabase/supabase";

export class Email {
    email: string;

    constructor(email: string) {
        this.email = email;
    }

    static async addNewEmail(email: string) {
        const { data, error } = await supabase
            .from("Emails")
            .insert({
                email: email,
            });
    }
}